import { Breadcrumb, Tabs } from 'antd'
import { useState } from 'react';
import ExplorerSearch from './ExplorerSearch';
import './Explorer.scss'
import Nodes from './Nodes';
import Loader from '../Loader/Loader'; 
import useGlobalLoader from '../../utils/globalLoader'; 

const Explorer = () => {
    const [activeTab, setActiveTab] = useState('1'); 
    const isLoading = useGlobalLoader();

    const onChange = (key) => {
        setActiveTab(key)
    };
    const items = [
        {
            key: 'nodes',
            label: 'Nodes',
            children: <Nodes isActive={activeTab === 'nodes'} />,
        },
        {
            key: 'explorer',
            label: 'Explorer',
            children: <ExplorerSearch />,
        }
    ];
    const bredCrumbItems = [
        {
            title: "Network Monitoring"
        },
        {
            title: "FLEXBLOK Explorer",
            href: `/block-explorer`
        }
    ]
    return (
        <div className='p-3 pt-1 explorer'>
            <div className='py-2 bg-white px-2 text-dark'>
                <Breadcrumb separator=">" items={bredCrumbItems} />
                <div className='mt-2'>
                    {isLoading && activeTab === '2' && <Loader />} {/* Conditionally render the Loader */}
                    <Tabs defaultActiveKey="1" items={items} onChange={onChange} centered />
                </div>
            </div>
        </div>
    )
}

export default Explorer